module.exports = __webpack_public_path__ + "img/certificates.9fc357f9.svg";